<template>
  <v-app id="inspire">
    <v-parallax
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      height="500"
    >
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <v-form
            @submit.prevent="onSubmit"
          >
            <v-card class="elevation-4">
              <v-toolbar
                color="primary"
                dark
              >
                <v-toolbar-title>Cuentas x cobrar</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="email"
                  label="Nombre de usuario"
                  name="username"
                  prepend-icon="mdi-account"
                  type="text"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  id="password"
                  label="Contraseña"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                >
                  Entrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
      </v-container>
    </v-parallax>
    <v-snackbar
      v-model="snackbar"
      color="error"
      timeout="3000"
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  export default {
    name: 'LoginComponent',
    data () {
      return {
        loading: false,
        snackbar: false,
        errorMessage: '',
      }
    },
    created () {
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('permissions')
      window.sessionStorage.removeItem('suc');//sucursales
      window.sessionStorage.removeItem('sucid');//sucursal
      window.sessionStorage.removeItem('pre');//precios
      window.sessionStorage.removeItem('pag');//formas de pago
      window.sessionStorage.removeItem('pro');//productos
      window.sessionStorage.removeItem('cho');//choferes
    },
    computed: {
      ...mapGetters('Auth', ['edited', 'errors']),
      email: {
        get () {
          return this.edited.email
        },
        set (value) {
          this.setEdited({
            ...this.edited,
            email: value
          })
        },
      },
      password: {
        get () {
          return this.edited.password
        },
        set (value) {
          this.setEdited({
            ...this.edited,
            password: value
          })
        },
      },
    },
    methods: {
      ...mapActions('Auth', ['onLogin', 'onPermisos']),
      ...mapMutations('Auth', ['setEdited']),
      async onSubmit() {
        try {
          this.loading = true
          // Realiza el login
          await this.onLogin()
          // Obtiene las sucursales asociadas al usuario
          this.$store.dispatch('Sucursales/onFetch').then(async response => {
            const sucursales = response.map(item => ({
              id: item.id,
              abreviatura: item.abreviatura,
              nombre: item.nombre,
            }));
            await window.sessionStorage.setItem('suc', JSON.stringify(sucursales))
            const aux = sucursales[0];
            this.$store.commit('Sucursales/setSelected', aux)
            await window.sessionStorage.setItem('sucid', aux.id)
          })
          .catch(error => {
            console.error('Error al cargar las sucursales:', error)
          });
          // Obtiene los productos
          await this.$store.dispatch('Productos/onFetch').then(response => {
            window.sessionStorage.setItem('pro', JSON.stringify(response))
          });
          // Obtiene las formas de pago
          await this.$store.dispatch('FormasPagos/onFetch').then(response => {
            window.sessionStorage.setItem('pag', JSON.stringify(response))
          });
          // Obtiene los precios
          await this.$store.dispatch('PreciosVigentes/onFetch').then(response => {
            const precios = response.map(item => ({
              id: item.id,
              vigencia: item.vigencia,
              subsidio: item.subsidio,
              usuario: item.usuario,
              pleno: item.pleno
            }));
            window.sessionStorage.setItem('pre', JSON.stringify(precios))
          });
          // Obtiene los parametros
          await this.$store.dispatch('Parametros/onFetch').then(response => {
            const parametros = response.map(item => ({
              id: item.id,
              nombre: item.nombre,
              valor: item.valor
            }));
            window.sessionStorage.setItem('par', JSON.stringify(parametros))
          });
          // Obtiene los choferes
          // await this.$store.dispatch('ChoferesAll/onFetch').then(response => {
          //   window.sessionStorage.setItem('cho', JSON.stringify(response))
          // });
          // Obtiene los permisos
          await this.onPermisos();
          this.loading = false
          // Redirige después de completar todas las llamadas
          this.$router.push({ name: 'cuentas-main' });
        } catch (error) {
          this.loading = false
          console.error('Error en el proceso de carga:', error);
          this.errorMessage = 'Credenciales incorrectas. Por favor verifique sus datos.';
          if (error.response && error.response.data && error.response.data.error) {
             this.errorMessage = error.response.data.error;
          }
          this.snackbar = true;
        }
      },
    },
  }
</script>